import React, { FunctionComponent } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Paper } from '@material-ui/core';
import { BASE_URL } from '../../../../routes';
import TableEmptyState from '../../../../components/TableView/TableEmptyState';
import { Order } from '../../../../store/modules/application/types';
import { Citation, CitationLicense } from '../../../../store/modules/citation/types';
import TableView from '../../../../components/TableView';

type CitationLicensesProps = {
    citationDetails: Citation;
    setSortOrder: Function;
    setSortColumn: Function;
    sortBy: string;
    sortOrder: Order;
};

interface IColumn {
    id: 'licenseNumber|string' | 'type|string' | 'status|string' | 'expirationDate|string';
    label: string;
    maxWidth?: number;
    align?: 'right' | 'left' | 'center';
    format?: (value: number) => string;
    field: string;
}
const columns: IColumn[] = [
    {
        id: 'licenseNumber|string',
        label: 'License Number',
        align: 'left',
        maxWidth: 200,
        field: 'licenseNumber',
    },
    {
        id: 'type|string',
        label: 'License Type',
        align: 'left',
        maxWidth: 300,
        field: 'type',
    },
    {
        id: 'status|string',
        label: 'Status',
        align: 'left',
        maxWidth: 200,
        field: 'status',
    },
    {
        id: 'expirationDate|string',
        label: 'Expiration Date',
        align: 'left',
        maxWidth: 300,
        field: 'expirationDate',
    },
];

const CitationLicenses: FunctionComponent<CitationLicensesProps> = (props) => {
    const { citationDetails, setSortColumn, setSortOrder, sortBy, sortOrder } = props;
    const history = useHistory();

    const onClickRow = (id: string, e: any) => {
        e.stopPropagation();
        routeChange(BASE_URL + `/license/${id}/detail`);
    };

    const routeChange = (path: string) => {
        history.push(path);
    };

    const citationLicenses = citationDetails?.licenses?.map((citationLicense: CitationLicense) => {
        const expiredDays = moment(Date.now()).diff(moment(citationLicense?.expirationDate), 'days');
        return {
            id: citationLicense.id,
            licenseNumber: citationLicense?.licenseNumber,
            type: citationLicense?.type?.name,
            status: citationLicense?.status,
            expirationDate:
                !!citationLicense?.expirationDate &&
                `${moment(citationLicense.expirationDate).format('L')}
                ${expiredDays > 0 ? expiredDays + ` days expired` : ''}  
                 `,
        };
    });

    return (
        <div className="verticalFillContainer">
            <Paper className="verticalFillContent fullHeight">
                {citationLicenses && citationLicenses.length > 0 ? (
                    <TableView
                        columns={columns}
                        data={citationLicenses}
                        count={citationLicenses.length}
                        onClickRow={onClickRow}
                        sortBy={sortBy}
                        sortOrder={sortOrder}
                        setSortColumn={setSortColumn}
                        setSortOrder={setSortOrder}
                    />
                ) : (
                    <TableEmptyState
                        title="No active records for this citation."
                        message="Licenses will be stored here "
                    ></TableEmptyState>
                )}
            </Paper>
        </div>
    );
};

export default CitationLicenses;
